<app-system-message></app-system-message>

@if (showLoadingOverlay) {
  <app-loading-element class="admin-loading-overlay"></app-loading-element>
}

<!-- Navbar whit the option of list we get -->
<header class="headerClass">
    <nav [ngClass]="theme.getThemeClass()" class="navbar navbar-expand-lg navbar-light bg-light">
      <div [ngClass]="theme.getThemeClass()" class="navbar-nav flex-nowrap divButton" id="navbarNavAltMarkup">
        <a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{ 'active' : isUserListActive }"
        (click)="userListClicked()">
        {{ 'adminViewUserListNavBar' | translate }}
        </a>
        <a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{ 'active' : isBinListActive }"
        (click)="binListClicked()">
        {{ 'adminViewBinListNavBar' | translate }}
        </a>
        <a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{ 'active' : isBinModelListActive }"
        (click)="binModelListClicked()">
        {{ 'adminViewBinModelListNavBar' | translate }}
        </a>
        <a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{ 'active' : isTaxeTypeActive }"
        (click)="taxeTypeClicked()">
        {{ 'taxeTypeViewTaxeType' | translate }}
        </a>
      </div>
    </nav>
</header>

<!-- List component that admin have -->
@if (this.isUserListActive) {
  <app-user-list class="userList"></app-user-list>
}
@if (this.isBinListActive) {
  <app-bin-list class="binList"></app-bin-list>
}
@if (this.isBinModelListActive) {
  <app-bin-model-list class="binModelList"></app-bin-model-list>
}
@if (this.isTaxeTypeActive) {
  <app-taxe-type-list class="taxeTypeList"></app-taxe-type-list>
}
